// extracted by mini-css-extract-plugin
export default {"nav":"AccountTabs_nav__1ZEsv","navList":"AccountTabs_navList__06U6+","links":"AccountTabs_links__E6L8D","active":"AccountTabs_active__E6pm8"};